import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import TaskNew from '../pages/projects/change-impacts/tasks/new';
import TaskEdit from '../pages/projects/change-impacts/tasks/edit';
import TaskShow from '../pages/projects/change-impacts/tasks/show';

export const taskRoutes = () => (
  <>
    <Route path={ROUTES.TASKS_NEW} element={<TaskNew />} />
    <Route path={ROUTES.TASKS_SHOW} element={<TaskShow />} />
    <Route path={ROUTES.TASKS_EDIT} element={<TaskEdit />} />
  </>
);
